
const getters = {
    appReady: state => state.appReady,
    snackbar: state => state.snackbar,
    mode: state => state.mode,
    cache: state => (key) => state.cache[key],
};

export default getters;